/* unplugin-vue-components disabled */import { render } from "./mapassembly.vue?vue&type=template&id=35c7a524&scoped=true"
import script from "./mapassembly.vue?vue&type=script&lang=js"
export * from "./mapassembly.vue?vue&type=script&lang=js"

import "./mapassembly.vue?vue&type=style&index=0&id=35c7a524&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c7a524"]])

export default __exports__